import apiFetch from "@wordpress/api-fetch";
import { useState, useEffect } from "@wordpress/element";
import Simple from "./components/simple/simple";
import Siliconas from "./components/siliconas/siliconas";
import Pisos from "./components/pisos/pisos";

function Data({calcType}){

  const [getPosts, setGetPosts] = useState([]);
  const [calculatorFilter, setcalculatorFilter] = useState([]);

  const fetchAllPosts = async () => {

      let path = `/wp/v2/calculator`;
      const newPosts = await apiFetch({path});
      setGetPosts(newPosts);
      await resultFilterByCat(newPosts);

      // Seleccionar el name del producto en la url
      const currentURL = window.location.href
      
      const url = new URL(currentURL)
      const nameProduct = url.searchParams.get("name_product")
      // url por #
      // var urlDividida = url.hash.split("#")
      // const seccionUrl = urlDividida[1]
      // const nameProduct = decodeURIComponent(urlDividida[2]) 

      // seleccionar el tab
      // var clase = `.c-calculator-tab-${seccionUrl}`
      // var padre = document.querySelector(clase);
      // var eventoClic = new Event('click'); 
      // if(padre){
      //   padre.dispatchEvent(eventoClic);
      // }

      
      setTimeout(function(){
        // buscar el producto en los select y seleccionarlo
        const selectProducts = document.querySelectorAll('.c-simple-cal__selector')
        selectProducts.forEach(element => {
          for(const option of element.options){
            if(option.text === nameProduct){
              option.selected = true;
              // disparo el evento del change para que seleccione el producto
              var eventoChange = new Event("change", { bubbles: true})
              element.dispatchEvent(eventoChange)
              break
            }
          }
        });
      }, 3000)
      
  }

  const resultFilterByCat = async (dataPost)=>{
      let filterCalProducts = dataPost;
      const dataFiltered = filterCalProducts.filter(e => {
          if(Array.isArray(e.block_data)){
            // const blockAttr = e.block_data[1].attrs;
            const blockAttr = e.block_data[0].attrs;
            if(Array.isArray(blockAttr.sistema)){
              const sistemValue = blockAttr.sistema[0].value;
              return calcType == sistemValue ?  true :  false
            }
          }
      })
      setcalculatorFilter(dataFiltered);
  }


  useEffect(() =>{
    fetchAllPosts();
  }, []);

  
  return(
    <> 
      {calcType == "decorativos" || calcType == "texturas" || calcType=="estucos" || calcType=="vinilos" ? 
        <Simple posts={calculatorFilter } typeCalc={calcType}/> : '' 
      }
      {calcType == "siliconas" ? 
        <Siliconas posts={calculatorFilter} typeCalc={calcType}/> : '' 
      }
      {calcType == "pisos" ? 
        <Pisos posts={calculatorFilter} typeCalc={calcType}/> : '' 
      }
    </>
  ) 
}
 
 
window.addEventListener("load", function(event){

  const showElements = document.querySelectorAll('.c-calculator');
  
  if(showElements){
    
    showElements.forEach( function(div){
      
      const calculatorType = div.getAttribute('data-calculator');
          const getCategories = document.querySelector('.js-show__'+calculatorType);         
          ReactDOM.render(<Data calcType={calculatorType} />, getCategories)
      })
    }
    
});
